<template>
  <div v-if="!(numPages === 1 && pageNum === 1)">
    <d-button
      theme="primary"
      light
      round
      size="sm"
      @click="prevClick"
      :disabled="prevButtonDisabled"
    >
      <i class="material-icons">arrow_back</i>
    </d-button>
    <strong class="mx-2"> Page {{ pageNum }} / {{ numPages }} </strong>
    <d-button
      theme="primary"
      light
      round
      size="sm"
      @click="nextClick"
      :disabled="nextButtonDisabled"
      ><i class="material-icons">arrow_forward</i></d-button
    >
  </div>
</template>

<script>

export default {
  name: "odd-paginator",
  props: {
    pageNum: {
      type: Number
    },
    numPages: {
      type: Number
    },
    nextClick: {
      type: Function
    },
    prevClick: {
      type: Function
    }
  },
  computed: {
    prevButtonDisabled() {
      return this.pageNum <= 1;
    },
    nextButtonDisabled() {
      return this.pageNum === this.numPages;
    }
  }
};
</script>

<style></style>
